// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@vanmeter/XDL/types";

import accordion from "@vanmeter/XDL/PreStyle/accordion";
import breadcrumbs from "@vanmeter/XDL/PreStyle/breadcrumbs";
import breakpoints from "@vanmeter/XDL/PreStyle/breakpoints";
import button from "@vanmeter/XDL/PreStyle/button";
import checkbox from "@vanmeter/XDL/PreStyle/checkbox";
import colors from "@vanmeter/XDL/PreStyle/colors";
import dataTable from "@vanmeter/XDL/PreStyle/dataTable";
import datePicker from "@vanmeter/XDL/PreStyle/datePicker";
import dynamicDropdown from "@vanmeter/XDL/PreStyle/dynamicDropdown";
import fieldSet from "@vanmeter/XDL/PreStyle/fieldSet";
import focus from "@vanmeter/XDL/PreStyle/focus";
import footer from "@vanmeter/XDL/PreStyle/footer";
import formField from "@vanmeter/XDL/PreStyle/formField";
import globalStyle from "@vanmeter/XDL/PreStyle/globalStyle";
import header from "@vanmeter/XDL/PreStyle/header";
import icon from "@vanmeter/XDL/PreStyle/icon";
import link from "@vanmeter/XDL/PreStyle/link";
import lists from "@vanmeter/XDL/PreStyle/lists";
import menu from "@vanmeter/XDL/PreStyle/menu";
import modal from "@vanmeter/XDL/PreStyle/modal";
import overflowMenu from "@vanmeter/XDL/PreStyle/overflowMenu";
import pagination from "@vanmeter/XDL/PreStyle/pagination";
import panelMenu from "@vanmeter/XDL/PreStyle/panelMenu";
import radio from "@vanmeter/XDL/PreStyle/radio";
import select from "@vanmeter/XDL/PreStyle/select";
import shadows from "@vanmeter/XDL/PreStyle/shadows";
import swatch from "@vanmeter/XDL/PreStyle/swatch";
import tab from "@vanmeter/XDL/PreStyle/tab";
import tag from "@vanmeter/XDL/PreStyle/tag";
import textArea from "@vanmeter/XDL/PreStyle/textArea";
import textField from "@vanmeter/XDL/PreStyle/textField";
import toast from "@vanmeter/XDL/PreStyle/toast";
import tooltip from "@vanmeter/XDL/PreStyle/tooltip";
import transition from "@vanmeter/XDL/PreStyle/transition";
import typography from "@vanmeter/XDL/PreStyle/typography";
import zIndex from "@vanmeter/XDL/PreStyle/zIndex";
import fileUpload from "@vanmeter/XDL/PreStyle/fileUpload";
import drawer from "@vanmeter/XDL/PreStyle/drawer";

export default {
    breakpoints,
    colors,
    focus,
    shadows,
    transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    fileUpload,
    header,
    formField,
    fieldSet,
    icon,
    // layoutTable,
    // layoutGroup,
    // layoutCell,
    link,
    lists,
    // lazyImage,
    // loadingOverlay,
    // loadingSpinner,
    menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    swatch,
    tab,
    tag,
    // tagsField,
    textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
    footer,
} as xBaseTheme;
